<!-- Cookie Consent Banner - Full Width Bottom -->
<div 
  *ngIf="isVisible()"
  [class.slide-up-enter]="!isExiting()"
  [class.slide-down-exit]="isExiting()"
  class="fixed bottom-0 left-0 right-0 z-[9999] bg-white border-t-2 border-indigo-200 shadow-[0_-8px_24px_rgba(99,102,241,0.15)]">
  
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
    <div class="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
      
      <!-- Left: Icon + Message -->
      <div class="flex items-start gap-3 flex-1">
        <!-- Cookie Icon -->
        <div class="flex-shrink-0 w-10 h-10 rounded-lg bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center shadow-md">
          <svg class="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 20 20">
            <path d="M10 2a8 8 0 100 16 8 8 0 000-16zM7 9a1 1 0 11-2 0 1 1 0 012 0zm4 0a1 1 0 11-2 0 1 1 0 012 0zm2 3a1 1 0 11-2 0 1 1 0 012 0z"/>
          </svg>
        </div>
        
        <!-- Message -->
        <div class="flex-1">
          <h3 class="text-lg font-bold text-slate-900 mb-1">🍪 เราใช้คุกกี้เพื่อปรับปรุงประสบการณ์ของคุณ</h3>
          <p class="text-base text-slate-600 leading-relaxed">
            เว็บไซต์นี้ใช้คุกกี้เพื่อให้บริการที่ดีขึ้นและวิเคราะห์การใช้งาน 
            <a href="/privacy-policy" class="text-indigo-600 hover:text-indigo-700 font-medium underline">อ่านนโยบายความเป็นส่วนตัว</a>
          </p>
        </div>
      </div>
      
      <!-- Right: Buttons -->
      <div class="flex items-center gap-3 w-full sm:w-auto">
        <!-- Reject Button (Optional) -->
        <button
          (click)="rejectAll()"
          class="flex-1 sm:flex-none px-5 py-2.5 text-base font-bold text-slate-600 bg-slate-100 hover:bg-slate-200 rounded-lg transition-all shadow-sm hover:shadow-md">
          ปฏิเสธ
        </button>
        
        <!-- Accept All Button -->
        <button
          (click)="acceptAll()"
          class="flex-1 sm:flex-none px-6 py-2.5 text-base font-bold text-white bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 rounded-lg transition-all shadow-md hover:shadow-lg">
          ยอมรับทั้งหมด
        </button>
      </div>
      
    </div>
  </div>
</div>
